export default {
  analogic: "Analógico",
  digital: "Digital",
  hybrid: "Híbrido",
  not_defined: "Não definido",
};
